import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  Grid,
  TextField,
  Typography,
  Button,
  Link,
  Alert,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Divider,
  Backdrop,
  CircularProgress,
  Box,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  AccountCircle,
  Visibility,
  VisibilityOff,
  Input as InputIcon,
  Key,
} from "@mui/icons-material";
import { AutContext } from "../context/AutContext";
import { AutLayout } from "../layout/AutLayout";
import { md5 } from "../md5";
import { useFormulario } from "../../hooks/useFormulario";
import { IdiomaContext } from "../../context/IdiomaContext";
import "animate.css";
import CustomCaptcha from "../../ui/components/utils/CustomCaptcha";
import { loadCaptchaEnginge, validateCaptcha } from "react-simple-captcha";
import InfoIcon from "@mui/icons-material/Info";
import { cfg } from "../../configuracion";
import { getVersionApi } from "../services/getVersionApi";
import { PublicTokenContext } from "../../context/PublicTokenContext";
import { checkCIF, checkNIF, checkTR } from "../../aut/NifValidator";
import {AppContext} from "../../context/AppContext";

export const EntrarPage = () => {
  const navigate = useNavigate();
  const [mostrarCargando, setMostrarCargando] = useState(false);
  const [mostrarError, setMostrarError] = useState(null);
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarDialogInfo, setMostrarDialogInfo] = useState(false);
  const [mostrarTextoPrivacidad, setMostrarTextoPrivacidad] = useState(false);
  const [mostrarDialogA2f, setMostrarDialogA2f] = useState(false)
  const [errorA2f, setErrorA2f] = useState("");
  const { habilitadoA2f, iniciarSesion, resetearEstadoA2F  } = useContext(AutContext);

  const [versionAPI, setVersionAPI] = useState(null);
  const { tokenCliente } = useContext(PublicTokenContext);

  
  const [erroresForm, setErroresForm] = useState({});
  const [selectTipoNif, setSelectTipoNif] = useState(false);
  const [tipoResidente, setTipoResidente] = useState("E");

  const { idioma, cad } = useContext(IdiomaContext);
  const {datosGenerales} = useContext(AppContext);

  const esMovil = useMediaQuery("(max-width:768px)");

  const [captchaValido, setCaptchaValido] = useState(false);
  const [captchaVisible, setCaptchaVisible] = useState(true);


  const [tiempoRestante, setTiempoRestante] = useState(0);
  const [contadorActivo, setContadorActivo] = useState(false);


  const { nif, a2f, clave, estadoForm, onCambiaCampo } = useFormulario({
    nif: "",
    clave: "",
    tipo: "",
    a2f: "",
    fase: 1,
  });


  const isValidNIF = (nif) => {
    return checkNIF(nif) || checkTR(nif);
  };

  const toggleDialogInfo = () => {
    setMostrarDialogInfo((prevState) => !prevState);
  };


  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };
  }, []);

  const handleCaptchaChange = (value) => {
    const esValido = validateCaptcha(value, false);
    setCaptchaValido(esValido);
    if (esValido) {
      setErroresForm((previo) => {
        return { ...previo, captcha: false };
      });
      setCaptchaVisible(false);
    }
  };

  const validarNif = (value) => {
    const resultado =
      !value || value.length <= 5 ? cad("ERR_NIF_CIF_INCORRECTO") : "";
    return resultado;
  };

  const onBlurNif = ({ target }) => {
    const { name, value } = target;
    const msg = validarNif(value);
    setSelectTipoNif(isValidNIF(value));

    console.log("RESULTADO NIF", msg);
    setErroresForm((prev) => {
      return {
        ...prev,
        [name]: msg,
      };
    });
  };

  const onCambiaNif = ({ target }) => {
    const { name, value } = target;
    const nValue = value
      .toUpperCase()
      .replace(/[^@#*ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789]/g, "");
    const isNIF = isValidNIF(nValue);

    setSelectTipoNif(isNIF);
    if (!isNIF) {
      setTipoResidente("E");
    } else {
      setTipoResidente("");
    }

    onCambiaCampo({ target: { name, value: nValue } });
  };

  const onCambiaRadio = (event) => {
    setTipoResidente(event.target.value);
    onCambiaCampo(event);
  };

  const onCambiaA2F = ({ target }) => {
    const { name, value } = target;
    const nValue = value.replace(/[^0-9]/g, "");
    onCambiaCampo({ target: { name, value: nValue } });
  };

  const validarClave = (value) => {
    return !value || value.trim().length <= 0
      ? cad("ERR_CAMPO_OBLIGATORIO")
      : "";
  };

  const onBlurClave = ({ target }) => {
    const { name, value } = target;
    const msg = validarClave(value);

    setErroresForm((prev) => {
      return {
        ...prev,
        [name]: msg,
      };
    });
  };

  const onBlurCaptcha = ({ target }) => {
    const { name, value } = target;
    const msg = !validateCaptcha(value, false)
      ? cad("ERR_CAMPO_OBLIGATORIO")
      : "";
    setErroresForm((prev) => {
      return {
        ...prev,
        [name]: msg,
      };
    });
  };

  const onCambiaMostrarClave = () => {
    setMostrarClave(!mostrarClave);
  };

  const onClickPoliticaPrivacidad = (e) => {
    e.preventDefault();
    setMostrarTextoPrivacidad(true);
  };

  const onCerrarTextoPrivacidad = () => {
    setMostrarTextoPrivacidad(false);
  };

  const onMostrarModalA2f = () => {
    setMostrarDialogA2f(true);
  };




// Asegurarse de que el modal se cierra correctamente
  const onCerrarModalA2f = () => {
    setMostrarDialogA2f(false);
    onCambiaCampo({ target: { name: "a2f", value: "" } });
    resetearEstadoA2F();
  };




  const onEntrar = async (event) => {
    event.preventDefault();

    if (mostrarDialogA2f && (!estadoForm.a2f || estadoForm.a2f.length !== 6)) {
      setErrorA2f(cad("CODIGO_A2F_INVALIDO"));
      return;
    }

    setMostrarCargando(true);
    setMostrarError(null);
    setErrorA2f("");

    try {
      if (!isValidNIF(estadoForm.nif)) {
        estadoForm.tipo = "E";
      }

      await iniciarSesion(
          estadoForm.nif,
          md5(estadoForm.clave),
          estadoForm.tipo,
          mostrarDialogA2f ? estadoForm.a2f : "",
          mostrarDialogA2f ? 2 : 1
      );

    } catch (err) {
      console.log("Error en login:", err.message);
      if (mostrarDialogA2f) {
        if (err.message.includes("CODIGO_A2F_INVALIDO")) {
          setErrorA2f(cad("CODIGO_A2F_INVALIDO"));
        } else if (err.message.includes("CODIGO_A2F_CADUCADO")) {
          setErrorA2f(cad("CODIGO_A2F_CADUCADO"));
        } else {
          setErrorA2f(err.message);
        }
      } else {
        setMostrarError(cad(err.message));
      }
    } finally {
      setMostrarCargando(false);
    }
  };




  // Añadir useEffect para manejar el estado del A2F
  useEffect(() => {
    if (habilitadoA2f) {
      setMostrarDialogA2f(true);
      setErrorA2f(""); // Limpiar error cuando se abre el modal
    }
  }, [habilitadoA2f]);


  useEffect(() => {
    // En caso de que exista algún error, establece el error a null y "simula un login" (con los datos incorrectos a proposito). Para capturar el error en el nuevo idioma.
    if (mostrarError) {
      setMostrarError(null);

      const fakeLogin = async () => {
        try {
          await iniciarSesion(
            estadoForm.nif,
            md5(estadoForm.clave),
            estadoForm.tipo,           
            a2f,
            idioma
          );
        } catch (err) {
          setMostrarError(err.message);
        }
      };

      fakeLogin();
    }
  }, [idioma]);



  useEffect(() => {
    if (erroresForm.nif)
      onBlurNif({ target: { name: "nif", value: estadoForm.nif } });
    if (erroresForm.clave)
      onBlurClave({ target: { name: "clave", value: estadoForm.clave } });
  }, [cad]);

  useEffect(() => {
    const fetchVersionAPI = async () => {
      const version = await getVersionApi(tokenCliente);
      setVersionAPI(version);
    };

    fetchVersionAPI();
  }, []);

  const reenviarCodigoVerificacion = async () => {
    try {
      setMostrarCargando(true);
      setMostrarError(null);
      setErrorA2f("");
      // Iniciar el contador
      setTiempoRestante(30);
      setContadorActivo(true);
      
      await iniciarSesion(
          estadoForm.nif,
          md5(estadoForm.clave),
          estadoForm.tipo,
          "", // No envías código A2F
          1,  // Fase 1 de nuevo
          idioma
      );

      
    } catch (err) {
      setMostrarError(err.message);
    } finally {
      setMostrarCargando(false);
    }
  };

// Añade este useEffect para controlar el contador
  useEffect(() => {
    let intervalo = null;

    if (contadorActivo && tiempoRestante > 0) {
      intervalo = setInterval(() => {
        setTiempoRestante((prevTiempo) => prevTiempo - 1);
      }, 1000);
    } else if (tiempoRestante === 0) {
      setContadorActivo(false);
      clearInterval(intervalo);
    }

    return () => {
      clearInterval(intervalo);
    };
  }, [contadorActivo, tiempoRestante]);




  return (
    <AutLayout>
      <Grid container item xs={12} justifyContent="center">
        <Grid
          item
          className={"box-shadow"}
          lg={3}
          sm={12}
          sx={{
            color: "primary.main",
            backgroundColor: "white.main",
            borderColor: "secondary.main",
            borderWidth: 2,
            borderStyle: "solid",
            px: esMovil ? 2 : 3,
            py: esMovil ? 1 : 3,
            mt: { lg: 5, sm: 2 },
            borderRadius: 2,
            pb: 0,
          }}
        >
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ m: 0, p: 0 }}>
              <Typography
                variant="h5"
                sx={{ visibility: esMovil ? "hidden" : "visible" }}
                color={"black.main"}
              >
                {cad("APR_TITULO_LOGIN")}
              </Typography>
            </Box>
            <Box
              onClick={() => toggleDialogInfo()}
              sx={{
                animation: "spin 3s infinite linear",
                "@keyframes spin": {
                  "0%": {
                    transform: "rotateY(0deg)",
                  },
                  "100%": {
                    transform: "rotateY(360deg)",
                  },
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <InfoIcon
                sx={{
                  fontSize: esMovil ? "2rem" : "2.5rem",
                  cursor: "pointer",
                  color: "inherit",
                }}
              />
            </Box>
          </Grid>

          {!esMovil && (
          <Grid item xs={12}>
            <Divider sx={{ mt: 1 }} />
          </Grid>
          )}

          <form onSubmit={onEntrar} autoComplete={"off"}>
            <Grid container>
              <Grid item xs={12} sx={{ mt: esMovil ? 1 : 2, mb: 1 }}>
                <TextField
                  error={Boolean(erroresForm.nif)}
                  helperText={erroresForm.nif}
                  label={cad("NIF_CIF")}
                  name="nif"
                  type="text"
                  placeholder={cad("NIF_CIF")}
                  onChange={onCambiaNif}
                  onBlur={onBlurNif}
                  value={nif}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle />
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    style: { textTransform: "uppercase" },
                    maxLength: 15,
                  }}
                />
              </Grid>

              {selectTipoNif && (
                <Grid item xs={12} sx={{ mt: 1, mb: 1, color: "black.main" }}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      {cad("TIPO_RESIDENTE")}
                    </FormLabel>
                    <RadioGroup
                      sx={{ display: "flex", flexDirection: "row", ml: 1 }}
                      aria-label="tipo"
                      name="tipo"
                      value={tipoResidente}
                      onChange={onCambiaRadio}
                    >
                      <FormControlLabel
                        value="P"
                        control={<Radio />}
                        label={cad("ES_PARTICULAR")}
                      />
                      <FormControlLabel
                        value="A"
                        control={<Radio />}
                        label={cad("ES_AUTONOMO")}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} sx={{ mt: 1, mb: 1 }}>
                <TextField
                  error={Boolean(erroresForm.clave)}
                  helperText={erroresForm.clave}
                  label={cad("CONTRASEÑA")}
                  name="clave"
                  type={mostrarClave ? "text" : "password"}
                  onChange={onCambiaCampo}
                  onBlur={onBlurClave}
                  placeholder={cad("CONTRASEÑA")}
                  value={clave}
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={onCambiaMostrarClave}
                          onMouseDown={onCambiaMostrarClave}
                        >
                          {mostrarClave ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              {captchaVisible && (
                <CustomCaptcha
                  reloadText={cad("GENERAR_OTRO_CAPTCHA")}
                  reloadColor="#347445"
                  loadCaptchaEnginge={loadCaptchaEnginge}
                  erroresForm={erroresForm}
                  estadoForm={estadoForm}
                  onBlur={onBlurCaptcha}
                  onCaptchaChange={handleCaptchaChange}
                  label={cad("TECLEE_EL_TEXTO")}
                />
              )}

              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    disabled={!captchaValido || !tipoResidente}
                    fullWidth
                    startIcon={<InputIcon />}
                    type={"submit"}
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white.main",
                      opacity: !captchaValido || !tipoResidente ? 0.6 : 1,
                      transition: "opacity 0.3s ease-in-out",
                      "&.hover": {
                        backgroundColor: "primary.hover",
                        color: "white.hover",
                        opacity: 1,
                      },
                    }}
                  >
                    {cad("ENTRAR")}
                  </Button>
                </Grid>

                {mostrarError && (
                  <Grid item xs={12}>
                    <Alert
                      variant="filled"
                      severity="error"
                      sx={{
                        pt: 0.5,
                        pb: 0.5,
                        textAlign: "center",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: 1,
                        color: "white.main",
                      }}
                    >
                      {mostrarError}
                    </Alert>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Divider sx={{ mb: 1 }} />
                </Grid>

                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  spacing={0}
                  color={"black.main"}
                >
                  <Grid item>
                    <Link
                      component={RouterLink}
                      color="inherit"
                      to="/aut/recuperar"
                      sx={{ fontSize: "0.875rem" }}
                    >
                      {cad("HE_OLVIDADO_MI_CONTRASEÑA")}
                    </Link>
                  </Grid>

                  <Grid item>
                    <Link
                      component={RouterLink}
                      color="inherit"
                      to="/aut/reenviarcorreo"
                      sx={{ fontSize: "0.875rem" }}
                    >
                      {cad("NO_RECIBIDO_CORREO_CONFIRMACION")}
                    </Link>
                  </Grid>

                  <Grid
                    item
                    sx={{
                      mt: "4px",
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="inherit"
                      align="center"
                      fontSize={"0.875rem"}
                    >
                      {cad("NO_TIENES_CUENTA")} -{" "}
                      <Link
                        component={RouterLink}
                        to="/aut/registrar"
                        sx={{
                          fontSize: "0.875rem",
                          color: "primary.main",
                          "&.hover": { color: "primary.hover" },
                        }}
                      >
                        {cad("REGISTRARSE")}
                      </Link>
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    sx={{
                      mt: "10px",
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="inherit"
                      align="center"
                      fontSize={"0.8rem"}
                    >
                      <Link onClick={(e) => onClickPoliticaPrivacidad(e)}
                        sx={{ cursor: "pointer" }}
                      >
                        {cad("POLITICA_PRIVACIDAD")}
                      </Link>
                    </Typography>
                  </Grid>

                  <Dialog
                    open={mostrarTextoPrivacidad}
                    onClose={onCerrarTextoPrivacidad}
                    scroll={"paper"}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                  >
                    <DialogTitle id="scroll-dialog-title">
                      {cad("POLITICA_PRIVACIDAD")}
                    </DialogTitle>
                    <DialogContent dividers={false}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: cad("APR_TEXTO_POLITICA_PRIVACIDAD"),
                        }}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={onCerrarTextoPrivacidad}>
                        {cad("CERRAR")}
                      </Button>
                    </DialogActions>
                  </Dialog>



                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ mt: 2, display: "flex", justifyContent: "center" }}
              ></Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
      <Grid item mt={4}>
        {mostrarCargando && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <Typography variant="h6" sx={{ mt: 2 }}>
                {cad("POR_FAVOR_ESPERE")}
              </Typography>
            </Box>
          </Backdrop>
        )}
      </Grid>

      <Dialog
        open={mostrarDialogInfo}
        onClose={() => setMostrarDialogInfo(false)}
      >
        <DialogTitle>
          {cad("INFORMACION")}
          <Divider sx={{ my: 1 }} />
        </DialogTitle>

        <DialogContent>
          <Typography variant="body1">
            {`${cad("APR_DESCRIPCION")}.`}
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: "500" }}>
            {`${cad("VERSION")}:`}
          </Typography>

          <Typography variant="subtitle2" sx={{ mt: 1, ml: 1 }}>
            - <strong>API</strong>: {versionAPI}
          </Typography>
          <Typography variant="subtitle2" sx={{ ml: 1 }}>
            - <strong>Web</strong>: {cfg.versionWeb}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => toggleDialogInfo()}>{cad("CERRAR")}</Button>
        </DialogActions>
      </Dialog>


      <Dialog
          open={mostrarDialogA2f}
          onClose={() => {/* No hacer nada al hacer clic fuera del modal */}}
          maxWidth="sm"
          fullWidth
      >
        <DialogTitle>{cad("INGRESE_CODIGO_VERIFICACION")}</DialogTitle>
        <DialogContent  sx={{ px: 2.5, py: 1 }}
        >
          <Typography variant="body1">
            {`${cad("MENSAJE_CODIGO_VERIFICACION")}`}
          </Typography>
          <TextField
              autoFocus
              margin="dense"
              name="a2f"
              label={cad("CODIGO_VERIFICACION")}
              type="text"
              fullWidth
              value={estadoForm.a2f}
              onChange={(e) => {
                onCambiaA2F(e);
                setErrorA2f("");
              }}
              inputProps={{
                maxLength: 6
              }}
              sx={{ mt:2 , mb: 2 }}
          />
          {errorA2f && (
              <Alert
                  severity="error"
                  variant="filled"
                  sx={{
                    width: '100%'
                  }}
              >
                {cad(errorA2f)}
              </Alert>
          )}
        </DialogContent>
        <DialogActions>

          <Button
              onClick={reenviarCodigoVerificacion}
              disabled={contadorActivo}
          >
            {contadorActivo
                ? `${cad("REENVIAR_CODIGO")} (${tiempoRestante}s)`
                : cad("REENVIAR_CODIGO")}
          </Button>




          <Button
              onClick={onCerrarModalA2f}
              color="error"
          >
            {cad("CERRAR")}
          </Button>

          <Button
              onClick={onEntrar}
              disabled={!estadoForm.a2f || estadoForm.a2f.length !== 6}
              color="primary"
          >
            {cad("VERIFICAR")}
          </Button>
          
        </DialogActions>
      </Dialog>






    </AutLayout>
  );
};